/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type IpWhitelistCreateDto = {
  tenantId: number;
  ipAddressRange: string;
  type: IpWhitelistCreateDto.type;
};
export namespace IpWhitelistCreateDto {
  export enum type {
    IPV4 = 'IPV4',
    IPV6 = 'IPV6',
  }
}

